import { defineMessage } from 'react-intl'

export const LoginMsg = defineMessage({ description: 'Auth.Login', defaultMessage: 'Log-in' })
export const LogoutMsg = defineMessage({ description: 'Auth.Logout', defaultMessage: 'Log-out' })
export const ProfileMsg = defineMessage({ description: 'Auth.Profile', defaultMessage: 'User details' })

